import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const PreviewBackground = styled.div`
  background: ${tokens.surface.base};
  min-height: 100vh;
  padding: ${tokens.space.lg};
  display: flex;
  flex-direction: column;
  gap: ${tokens.space.lg};
`

export const PreviewRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.space.sm};
`

export const PreviewHeaderActions = styled.div`
  margin-left: auto;
`

export const PreviewSidebar = styled.div`
  width: 13.75rem;
  display: flex;
  flex-direction: column;
  gap: ${tokens.space.xs};
`

export const PreviewBody = styled.div`
  display: flex;
  gap: ${tokens.space.lg};
`

export const PreviewMain = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${tokens.space.md};
`

export const PreviewMetrics = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: ${tokens.space.sm};
`

export const PreviewTitle = styled.div`
  font-size: ${tokens.font.h1};
  font-weight: 500;
  color: ${tokens.text.primary};
`

export const PreviewStaffRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.space.sm};
`

export const PreviewStaffName = styled.div`
  flex: 1;
  min-width: 0;
  font-size: ${tokens.font.body};
  color: ${tokens.text.primary};
`

export const PreviewPillRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
`

export const PreviewFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.75rem;
`
